/******/ (() => {
  // webpackBootstrap
  var isDefined = customElements.get("localization-form");

  if (!isDefined) {
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();

        this.thing = 0;

        this.elements = {
          input: this.querySelector(
            'input[name="language_code"],input[name="country_code"],input[name="domain_name"]'
          ),
          button: this.querySelector("button"),
          panel: this.querySelector("ul"),
        };

        this.isDomainForm = this.classList.contains("domain-form");

        this.elements.button.addEventListener(
          "click",
          this.openSelector.bind(this)
        );

        this.elements.button.addEventListener(
          "blur",
          this.closeSelector.bind(this)
        );

        this.addEventListener("keyup", this.onContainerKeyUp.bind(this));

        this.elements.panel.querySelectorAll("a").forEach((item) => {
          item.addEventListener("click", this.onItemClick.bind(this));
        });
      }

      hidePanel() {
        this.elements.button.setAttribute("aria-expanded", "false");
        this.elements.panel.setAttribute("hidden", true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== "ESCAPE") return;

        this.hidePanel();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();

        if (this.isDomainForm) {
          if (this.elements.input.value === event.currentTarget.dataset.value)
            return;

          const newLocation = new URL(window.location);
          newLocation.host = event.currentTarget.dataset.value;
          const re = new RegExp("^/[a-zA-Z][a-zA-Z](/|$)");

          // If the pathname has a language prefix, remove it
          if (re.test(newLocation.pathname)) {
            newLocation.pathname = newLocation.pathname.replace(re, "/");
          }

          window.location.href = newLocation.toString();
        } else {
          const form = this.querySelector("form");
          this.elements.input.value = event.currentTarget.dataset.value;
          if (form) form.submit();
        }
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute("hidden");
        this.elements.button.setAttribute(
          "aria-expanded",
          (
            this.elements.button.getAttribute("aria-expanded") === "false"
          ).toString()
        );
      }

      closeSelector(event) {
        const shouldClose =
          !event.relatedTarget?.classList?.contains("disclosure__item_el") &&
          !event.relatedTarget?.classList?.contains("disclosure__item");

        if (shouldClose) {
          this.hidePanel();
        }
      }
    }

    customElements.define("localization-form", LocalizationForm);
  }
  /******/
})();
